import React from 'react'
import './Index.css'

const AboutUs = () => {
    return (
        <div >
            <h1 className = 'AboutEditText text-center'>About Us</h1>
            <div className = 'LinkContainer'>
            <div className = 'AboutEditText2 text-center'>We are a team of innovative, creative and experienced professional problem solvers. We use the latest technologies to give that extra edge in bringing your idea to reality.
            <br /> <br /> 
           Address: House No-42, Ground Floor, Block-B, Pkt-8, Sector-5, Rohini, New Delhi - 110085
            <br /> <br /> 
           
            </div>
            </div>
        </div>
    )
}

export default AboutUs